// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.small_chatbot {
    width: 300px;  /* Set desired width */
    height: 400px; /* Set desired height */
  }
  
  .small_chatbot iframe {
    width: 100%;
    height: 100%;
  }
  
  .small_chatbot button {
    padding: 4px 8px;    /* Decrease the button padding */
    font-size: 14px;     /* Decrease the button font size */
    min-width: 10px;     /* Optionally set a minimum width */
    height: 30px;        /* Decrease the button height */
  }
  
  /* Example of targeting buttons inside the ChatBot component */
  .react-rcb-chat-tooltip {
    font-size: 12px;   /* Decrease font size */
    padding: 5px 10px; /* Decrease padding to make the button smaller */
    width: auto;       /* Adjust the width as needed */
    height: auto;      /* Adjust the height as needed */
  }
  
  .rcb-chat-tooltip.rcb-tooltip-show {
    /* width: 100px !important; */
    font-size: 13px;
    bottom: 20px !important;
    right: 88px !important;
    height: 48px !important;
    background-color: #1D3D63 !important ;
  }
  
  .rcb-chat-tooltip-tail{
    border-color: transparent transparent transparent #1D3D63 !important ;
  }
  .rcb-toggle-button.rcb-button-show {
    width: 50px !important;
    height: 50px !important;
    font-size: 13px;
  }
  
  .rcb-chat-window{
    height: 450px !important;
    font-size: 12px !important;
    width: 440px !important;
  }
  .rcb-bot-message-container{
    font-size: 9px !important;
  }
  
  .rcb-chat-body-container{
  font-size: small !important;
  }
  
  /* .rcb-chat-input{
  height: 50px;
  padding-bottom: 0 !important;
  margin-bottom: 0;
  font-size: small !important;
  }
  
  .rcb-bot-message-entry{
  height: 25px !important;
  text-align: center !important;
  display: flex !important;
  padding-top: 0 !important;
  } */
  
  .rcb-chat-header-container{
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  background-color: #83A4CF !important;
  /* background-image: linear-gradient(right , #83A4CF , #acbdd4 ) ; */
  /* background-image: linear-gradient(right ,#1D3D63, #83A4CF ) ; */
  /* background-image: linear-gradient(#83A4CF) !important; */
  }
  
  .rcb-chat-footer-container{
  display: none !important;
  padding-top: 4px !important;
  padding-bottom: 1px !important;
  }
  
  .rcb-chat-footer{
  display: none;
  }
  
  .rcb-chat-input-textarea{
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  }
  
  .rcb-chat-input{
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  }
  
  .rcb-bot-avatar {
  display: none;
  }
  
  .rcb-notification-icon-on {
  display: none !important;
  }
  
  .rcb-bot-message.rcb-bot-message-entry{
  font-size: 12px !important;
  text-align: left;
  }
  .rcb-user-message.rcb-user-message-entry{
  font-size: 12px !important;
  }
  
  .rcb-send-button{
  background-color: #83A4CF !important;
  }
  .rcb-send-button:hover{
  background-color: #b1c7e4!important;
  }
  
  .rcb-chat-header{
  /* display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  font-size: medium !important;
  width: 100%; */
  /* width: -webkit-fill-available !important; */
  
  }
  
  .rcb-user-message.rcb-user-message-entry{
  background-color: #83A4CF !important;
  color: black;
  }
  
  .rcb-bot-message.rcb-bot-message-entry{
  background-color: #1D3D63 !important;
  }
  
  .rcb-chat-header-container {
  /* background-image: linear-gradient(to right, #83A4CF, #a9c4e8) !important; */
  background-image: linear-gradient(to right, #1D3D63, #83A4CF) !important;
  }
  
  .rcb-chat-header-container > .rcb-chat-header:first-child{
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  font-size: large !important;
  width: 100%;
  font-weight: 600;
  }
  
  .rcb-badge{
  display: none !important;
  }`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Kratos/VehicleInsights_Kratos/VehicleInsightKratos.css"],"names":[],"mappings":"AAAA;IACI,YAAY,GAAG,sBAAsB;IACrC,aAAa,EAAE,uBAAuB;EACxC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB,KAAK,gCAAgC;IACrD,eAAe,MAAM,kCAAkC;IACvD,eAAe,MAAM,mCAAmC;IACxD,YAAY,SAAS,+BAA+B;EACtD;;EAEA,8DAA8D;EAC9D;IACE,eAAe,IAAI,uBAAuB;IAC1C,iBAAiB,EAAE,gDAAgD;IACnE,WAAW,QAAQ,+BAA+B;IAClD,YAAY,OAAO,gCAAgC;EACrD;;EAEA;IACE,6BAA6B;IAC7B,eAAe;IACf,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,qCAAqC;EACvC;;EAEA;IACE,qEAAqE;EACvE;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;;EAEA;EACA,2BAA2B;EAC3B;;EAEA;;;;;;;;;;;;KAYG;;EAEH;EACA,2BAA2B;EAC3B,8BAA8B;EAC9B,oCAAoC;EACpC,oEAAoE;EACpE,kEAAkE;EAClE,2DAA2D;EAC3D;;EAEA;EACA,wBAAwB;EACxB,2BAA2B;EAC3B,8BAA8B;EAC9B;;EAEA;EACA,aAAa;EACb;;EAEA;EACA,yBAAyB;EACzB,4BAA4B;EAC5B;;EAEA;EACA,2BAA2B;EAC3B,8BAA8B;EAC9B;;EAEA;EACA,aAAa;EACb;;EAEA;EACA,wBAAwB;EACxB;;EAEA;EACA,0BAA0B;EAC1B,gBAAgB;EAChB;EACA;EACA,0BAA0B;EAC1B;;EAEA;EACA,oCAAoC;EACpC;EACA;EACA,mCAAmC;EACnC;;EAEA;EACA;;;;gBAIc;EACd,8CAA8C;;EAE9C;;EAEA;EACA,oCAAoC;EACpC,YAAY;EACZ;;EAEA;EACA,oCAAoC;EACpC;;EAEA;EACA,8EAA8E;EAC9E,wEAAwE;EACxE;;EAEA;EACA,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB;;EAEA;EACA,wBAAwB;EACxB","sourcesContent":[".small_chatbot {\n    width: 300px;  /* Set desired width */\n    height: 400px; /* Set desired height */\n  }\n  \n  .small_chatbot iframe {\n    width: 100%;\n    height: 100%;\n  }\n  \n  .small_chatbot button {\n    padding: 4px 8px;    /* Decrease the button padding */\n    font-size: 14px;     /* Decrease the button font size */\n    min-width: 10px;     /* Optionally set a minimum width */\n    height: 30px;        /* Decrease the button height */\n  }\n  \n  /* Example of targeting buttons inside the ChatBot component */\n  .react-rcb-chat-tooltip {\n    font-size: 12px;   /* Decrease font size */\n    padding: 5px 10px; /* Decrease padding to make the button smaller */\n    width: auto;       /* Adjust the width as needed */\n    height: auto;      /* Adjust the height as needed */\n  }\n  \n  .rcb-chat-tooltip.rcb-tooltip-show {\n    /* width: 100px !important; */\n    font-size: 13px;\n    bottom: 20px !important;\n    right: 88px !important;\n    height: 48px !important;\n    background-color: #1D3D63 !important ;\n  }\n  \n  .rcb-chat-tooltip-tail{\n    border-color: transparent transparent transparent #1D3D63 !important ;\n  }\n  .rcb-toggle-button.rcb-button-show {\n    width: 50px !important;\n    height: 50px !important;\n    font-size: 13px;\n  }\n  \n  .rcb-chat-window{\n    height: 450px !important;\n    font-size: 12px !important;\n    width: 440px !important;\n  }\n  .rcb-bot-message-container{\n    font-size: 9px !important;\n  }\n  \n  .rcb-chat-body-container{\n  font-size: small !important;\n  }\n  \n  /* .rcb-chat-input{\n  height: 50px;\n  padding-bottom: 0 !important;\n  margin-bottom: 0;\n  font-size: small !important;\n  }\n  \n  .rcb-bot-message-entry{\n  height: 25px !important;\n  text-align: center !important;\n  display: flex !important;\n  padding-top: 0 !important;\n  } */\n  \n  .rcb-chat-header-container{\n  padding-top: 6px !important;\n  padding-bottom: 6px !important;\n  background-color: #83A4CF !important;\n  /* background-image: linear-gradient(right , #83A4CF , #acbdd4 ) ; */\n  /* background-image: linear-gradient(right ,#1D3D63, #83A4CF ) ; */\n  /* background-image: linear-gradient(#83A4CF) !important; */\n  }\n  \n  .rcb-chat-footer-container{\n  display: none !important;\n  padding-top: 4px !important;\n  padding-bottom: 1px !important;\n  }\n  \n  .rcb-chat-footer{\n  display: none;\n  }\n  \n  .rcb-chat-input-textarea{\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  }\n  \n  .rcb-chat-input{\n  padding-top: 2px !important;\n  padding-bottom: 2px !important;\n  }\n  \n  .rcb-bot-avatar {\n  display: none;\n  }\n  \n  .rcb-notification-icon-on {\n  display: none !important;\n  }\n  \n  .rcb-bot-message.rcb-bot-message-entry{\n  font-size: 12px !important;\n  text-align: left;\n  }\n  .rcb-user-message.rcb-user-message-entry{\n  font-size: 12px !important;\n  }\n  \n  .rcb-send-button{\n  background-color: #83A4CF !important;\n  }\n  .rcb-send-button:hover{\n  background-color: #b1c7e4!important;\n  }\n  \n  .rcb-chat-header{\n  /* display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  font-size: medium !important;\n  width: 100%; */\n  /* width: -webkit-fill-available !important; */\n  \n  }\n  \n  .rcb-user-message.rcb-user-message-entry{\n  background-color: #83A4CF !important;\n  color: black;\n  }\n  \n  .rcb-bot-message.rcb-bot-message-entry{\n  background-color: #1D3D63 !important;\n  }\n  \n  .rcb-chat-header-container {\n  /* background-image: linear-gradient(to right, #83A4CF, #a9c4e8) !important; */\n  background-image: linear-gradient(to right, #1D3D63, #83A4CF) !important;\n  }\n  \n  .rcb-chat-header-container > .rcb-chat-header:first-child{\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  font-size: large !important;\n  width: 100%;\n  font-weight: 600;\n  }\n  \n  .rcb-badge{\n  display: none !important;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
